<template>
  <div class="collection-flow">
    <div class="flow-item" v-for="(val, key) in media" :key="key">
      <div>
        <img :src="keyToImg(key)" alt="">
      </div>
      <p class="name">{{ key }}</p>
      <span class="value">{{ toFixed2(val) }}</span>
    </div>
  </div>
</template>

<script>
import { getCollectionFlowApi } from '@/api/Dashboard/'
export default {
  data() {
    return {
      media: {
        // Facebook: 1089,
        // Twitter: 11421,
        // YouTube: 540,
        // 今日头条: 405,
        // 新浪微博: 1800,
        新闻网站: 0,
        云媒体:0,
        微信公众号:0,
        文献:0


      }
    }
  },
  created() {
    this.getCollectionFlow()
  },
  methods: {
    keyToImg(title) {
      switch (title) {
        // case 'Facebook' :
        //   return require('../img/facebook.png')
        // case 'Twitter' :
        //   return require('../img/twitter.png')
        // case 'YouTube' :
        //   return require('../img/youtube.png')
        // case '今日头条' :
        //   return require('../img/toutiao.png')
        // case '新浪微博' :
        //   return require('../img/weibo.png')
        case '新闻网站' :
          return require('../img/news.png')

        case '云媒体' :
          return require('../../../assets/Site/ExhibitionBoard/API.png')

        case '微信公众号' :
          return require('../../../assets/Site/ExhibitionBoard/wechat.png')

        case '文献' :
          return require('../img/document.png')

      }
    },
    toFixed2(val) {
      return Number(val).toFixed(0)
    },

    getCollectionFlow() {
      getCollectionFlowApi({"isRealData":true}).then((res) => {
        this.media = res
      })
    }
  }
}
</script>

<style lang="less" scoped>
.collection-flow {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  .flow-item {
    width: 33.33%;
    text-align: center;
    img{
      width: 70px;
      height: 70px;
    }
    .name{
      color: #333;
      font-size: 14px;
      font-weight: bold;
      margin: 10px 0 ;
    }

    .value{
      display: inline-block;
      width: 66px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #E2E2E2;
      color: #000033;
      margin-bottom: 15px;
    }
  }
}
</style>
